import { mapServerToSpecificationsBase } from './map-server-to-specifications-base.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';

const mapServerToSunglassesSpecifications = (serverVariant, brand, prescriptionGlass)=>{
    const { segment , trend , lensFeatures , frameFeatures , roadworthiness  } = serverVariant.variantTypeDetails;
    const { lensColor , isGlazeble , isPolarized  } = lensFeatures || {};
    const { color: frameColor , shape: frameShape , material: frameMaterial , type: frameType , size: frameSize , templeType ,  } = frameFeatures || {};
    const serverSpecifications = {
        segment,
        frameShape: frameShape === null || frameShape === void 0 ? void 0 : frameShape.displayName,
        lensColor,
        frameColor,
        frameMaterial,
        frameType,
        frameSize: frameSize === null || frameSize === void 0 ? void 0 : frameSize.displayName,
        isGlazeble,
        isPolarized,
        templeType,
        trend,
        roadworthiness,
        prescriptionGlass
    };
    return [
        ...mapServerToSpecificationsBase(serverVariant, brand),
        ...getSpecificationItems(serverSpecifications), 
    ];
};

export { mapServerToSunglassesSpecifications };
//# sourceMappingURL=map-server-to-sunglasses-specifications.js.map
